<template>
  <div class="content-panel">
    <a-input-search
      v-model="subcompanyname"
      style="margin-bottom: 8px"
      placeholder="请输入所属公司"
      @search="queryDictData"
      @pressEnter="queryDictData"
    />
    <a-spin :spinning="loading" wrapperClassName="spin">
      <a-card :bordered="false">
        <a-tree
          class="deptTreeModules"
          style="height:100%"
          v-if="treeData.length > 0"
          :treeData="treeData"
          :draggable="false"
          @check="searchAssetTypeList"
          :showIcon="false"
          :checkedKeys="checkedKeys"
          :defaultExpandedKeys="defaultExpandedKeys"
          checkable
        >
          <template slot="custom" slot-scope="item">
            <span class="deptTreeCompanyName">{{ item.url }}</span>
          </template>
        </a-tree>
      </a-card>
    </a-spin>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex'
import { getDeptTreeList } from '@/api/assetLedger'
export default {
  name: 'OrgTree',
  props: ['isOut'],
  computed: {
    ...mapGetters(['assetCompanyIdArr'])
  },
  data () {
    return {
      loading: false,
      subcompanyname: '',
      treeData: [],
      defaultCheckedKeys: [],
      defaultExpandedKeys: [],
      checkedKeys: [],
      // 用于测试
      code: 'null0',
      numberOfUpdates: 0
    }
  },
  beforeCreate () {
    this.form = this.$form.createForm(this, { name: 'dept_form' })
  },
  created () {
    // 获取使用部门
    this.getDeptData()
  },
  methods: {
    ...mapActions(['handleAssetEchartsCompanyId']),
    formateData (arr, id, subcompanycode) {
      const f_arr = []
      const self = this
      if (arr && arr.length > 0) {
        for (let i = 0; i < arr.length; i++) {
          const item = JSON.parse(JSON.stringify(arr[i]))
          item.key = item.id
          item.scopedSlots = { title: 'custom' }
          if (item.type === 2) {
            item.subcompanycode = subcompanycode
          }
          if (item.children && item.children.length) {
            item.children = self.formateData(item.children, item.id, item.subcompanycode)
          }
          f_arr.push(item)
        }
      }
      return f_arr
    },
    // 获取使用部门
    async getDeptData (type) {
      const data = {
        paging: false,
        subcompanyname: this.subcompanyname
      }
      this.loading = true
      getDeptTreeList(data).then(res => {
        if (res.status === 0) {
          if (res.data.length > 0) {
            res.data.map(item => {
              item.key = item.id
              item.scopedSlots = { title: 'custom' }
              item.children = this.formateData(item.children, item.id, item.subcompanycode)
            })
            if (!type) {
              this.defaultCheckedKeys = this.assetCompanyIdArr.id === '空' ? [] : this.assetCompanyIdArr.id
              this.checkedKeys = this.assetCompanyIdArr.id === '空' ? [] : this.assetCompanyIdArr.id
              this.defaultExpandedKeys = this.assetCompanyIdArr.id === '空' ? [] : this.assetCompanyIdArr.id
              this.handleAssetEchartsCompanyId({
                comid: this.checkedKeys,
                numberOfUpdates: this.numberOfUpdates++
              })
            }
            if (!this.subcompanyname) {
              this.treeData = [{
                id: '杭氧',
                key: '杭氧',
                scopedSlots: { title: 'custom' },
                url: '杭氧',
                code: '杭氧',
                parent: true,
                children: res.data
              }]
            } else {
              this.treeData = res.data
            }
          } else {
            this.treeData = res.data
            // this.defaultCheckedKeys = []
            // this.defaultExpandedKeys = []
            // this.checkedKeys = []
          }
          this.loading = false
        } else {
          this.$message.error(res.info.message)
          this.loading = false
        }
      })
    },
    // 调用父组件的获取资产类型数据方法
    searchAssetTypeList (data, info) {
      this.checkedKeys = data
      this.handleAssetEchartsCompanyId({
        comid: data,
        numberOfUpdates: this.numberOfUpdates++
      })
    },
    // 搜索设备分类
    queryDictData () {
      this.getDeptData('search')
    }
  }
}
</script>
<style lang="less">
.ant-modal-body {
  #chart-container {
    overflow-x: auto;
  }
}

.ant-tooltip {
  z-index: 1020;
}
.content-panel {
  height: 100%;
  .action-btn-line {
    display: flex;
    justify-content: space-between;
  }

  .ant-tree-title {
    width: 100%;

    & > span {
      // width: 90px;
      display: inline-block;
      white-space: pre-line !important;
    }
  }
  .title {
    float: left;
  }

  .ant-card-body {
    padding: 0;

    :global {
      .ant-tree {
        line-height: 3;

        .ant-tree-node-content-wrapper,
        .ant-tree-switcher {
          height: auto;
          margin-top: 5px;
          margin-bottom: 5px;
        }
        .ant-tree-switcher_close{
          background: url('../../../../../src/assets/icon-close.svg') no-repeat 5px 4px !important;
          svg{
            display: none !important;
          }
        }
        .ant-tree-node-content-wrapper:hover {
          background: transparent;
        }
        .ant-tree-treenode-selected {
          background: #e6f7ff;
          height: auto !important;
          .ant-tree-node-selected {
            background: transparent;
          }
        }

        .ant-tree-child-tree {
          background: #fff;
        }
        li {
          position: relative;
          line-height: 3;
          padding-bottom: 0;
        }
      }
      .ant-btn {
        margin-bottom: 8px;
      }
    }

    .icon-panel {

      .anticon-plus,
      .anticon-setting,
      .anticon-edit,
      .anticon-delete {
        margin-left: 5px;
        color: #1890ff;
      }
    }
  }
}
/deep/.ant-tree-treenode-switcher-close  {
  display: flex;
  flex-direction: row;
  align-items: center;
  padding: 0 0 4px 0 !important;
  height: auto;
  margin: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-close {
  height: auto;
}
/deep/.ant-tree-treenode-switcher-open {
  padding: 0 !important;
}
/deep/.ant-tree-node-content-wrapper-open {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-content-wrapper {
  margin: 0 !important;
  height: auto;
}
/deep/.ant-tree-node-selected {
  height: auto;
}
.content-panel .ant-tree li {
  margin: 0!important;
  padding: 0!important;
  height: auto;
}
.content-panel .ant-tree li .ant-tree-child-tree {
  margin: 0!important;
}
/deep/.ant-tree li {
  margin: 0!important;
  padding: 0!important;
}
.spin {
  height: calc(100% - 40px);
  overflow: auto;
}
.deptTreeModules {
  overflow: hidden !important;
}
.deptTreeCompanyName {
  font-size: 14px;
  margin-right: 25px;
  margin-top: 2px;
}
</style>
